import { useState } from 'react';
import { useSale } from '../sale/useSale';
import { PreviewDocumentType } from '../../types/pdf/PreviewDocumentType';
import { blobToBase64 } from '../../utils/blobToBase64';
import { useSalePreview } from '../sale/useSalePreviewDispatcher';

export const useSalePreviewHandler = () => {
  const [base64Pdf, setBase64Pdf] = useState<string | undefined>();
  const [fileName, setFileName] = useState<string>('documento.pdf');

  const { form } = useSale();
  const { fetchPdfBlob } = useSalePreview();

  const handleViewDocument = async (selectedDoc: { id: number; code: string }) => {
    const saleId = form.id;
    const branchId = form.branch?.id;
    const docType = selectedDoc.code as PreviewDocumentType;

    if (!saleId || !docType) {
      console.warn('⚠️ Falta el ID de la venta o el tipo de documento');
      return;
    }

    try {
      // 👇 Este método ya devolverá { blob, fileName }
      const { blob, fileName } = await fetchPdfBlob(saleId, branchId, docType);

      if (blob) {
        const base64 = await blobToBase64(blob);
        setBase64Pdf(base64);
        if (fileName) setFileName(fileName);
      } else {
        console.warn('⚠️ No se pudo obtener el PDF del servidor');
      }
    } catch (err) {
      console.error('❌ Error al generar el documento:', err);
    }
  };

  return {
    base64Pdf,
    fileName,
    setBase64Pdf,
    handleViewDocument,
  };
};
